import { contentRouteCreator } from './actions';
import contentReady from './helpers/content';
import { getMetadata } from './selectors';

const createPublicApi = store => ({
  store,
  loadContent: async uid => {
    store.dispatch(contentRouteCreator(uid));
    const content = await contentReady(store);
    return {
      ...content,
      metadata: getMetadata(store.getState()),
    };
  },
});

export default createPublicApi;
